import SuggestPrice from './SuggestPrice';

export default SuggestPrice;
